export default __webpack_public_path__ + "static/media/more.e0ea38e7.svg";